module.exports = __webpack_public_path__ + "img/Castellon.38f7825c.jpg";